import { KeyValue } from '@angular/common';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { StringValidators } from '@howdeniberia/core-front';
import { YesNoValue } from 'src/app/core/enums';
import { IMasterValue } from 'src/app/core/models/api/master';

export class EditViewModel {
  editForm: FormGroup;

  paymentTypesData: Array<IMasterValue> = [];
  activitiesData: Array<IMasterValue> = [];
  sportsData: Array<IMasterValue> = [];
  livingStandardsData: Array<IMasterValue> = [];
  deadlineIPTsData: Array<IMasterValue> = [];
  contributionRETAsData: Array<IMasterValue> = [];
  contributionGeneralRegsData: Array<IMasterValue> = [];
  mutualIncomesData: Array<IMasterValue> = [];
  motorbikesData: Array<IMasterValue> = [];
  yesNoValuesData: KeyValue<YesNoValue, string>[] = [];
  maritalStatusesData: IMasterValue[] = [];
  childrenData: IMasterValue[] = [];

  cClientId = 'projectClientId';
  cClientName = 'projectClientName';
  cClientBirthdate = 'projectClientBirthDate';
  cClientAge = 'projectClientAge';
  cClientProfession = 'projectClientProfession';
  cClientProvince = 'projectClientProvince';
  cClientActuarialage = 'projectClientActuarialAge';
  cClientAddresszipcode = 'projectClientAddressZipcode';
  cClientOfficealias = 'projectClientOfficeAlias';
  cClientOfficecode = 'projectClientOfficeCode';
  cClientOfficename = 'projectClientOfficeName';
  cClientProfessioncode = 'projectClientProfessionCode';
  cClientSex = 'projectClientSex';

  cProjectId = 'projectId';
  cProjectName = 'projectName';
  cEffectiveDate = 'projectEffectiveDate';
  cPaymentType = 'projectPaymentType';
  cActivity = 'projectActivity';
  cSport = 'projectSport';
  cIndustryLife = 'projectIndustryLife';
  cIndustryAccident = 'projectIndustryAccident';
  cIndustryTemporaryIncapacity = 'projectIndustryTemporaryIncapacity';
  cIndustryDependency = 'projectIndustryDependency';
  cIndustryWholeLife = 'projectIndustryWholeLife';
  cIndustryDeath = 'projectIndustryDeath';
  cLifeDrivingForce = 'projectLifeDrivingForce';
  cLifeScaffoldRoof = 'projectLifeScaffoldRoof';
  cLifeSpecialRisks = 'projectLifeEspecialRisks';
  cLifeMotorbike = 'projectLifeMotorbike';
  cLivingStandard = 'projectLivingStandard';
  cDeadlineIpt = 'projectDeadlineIPT';
  cContributionReta = 'projectContributionRETA';
  cContributionGeneralRegime = 'projectContributionGeneralReg';
  cMarried = 'projectMarried';
  cMutualIncome = 'projectMutualIncome';
  cMinorChildren = 'projectMinorChildren';

  constructor(fb: FormBuilder) {
    this.editForm = fb.group({
      [this.cClientId]: new FormControl('', [Validators.required]),
      [this.cClientName]: new FormControl('', []),
      [this.cClientBirthdate]: new FormControl('', []),
      [this.cClientAge]: new FormControl('', []),
      [this.cClientProfession]: new FormControl('', []),
      [this.cClientProvince]: new FormControl('', []),
      [this.cClientActuarialage]: new FormControl('', []),
      [this.cClientProfessioncode]: new FormControl('', []),
      [this.cClientOfficename]: new FormControl('', []),
      [this.cClientOfficecode]: new FormControl('', []),
      [this.cClientAddresszipcode]: new FormControl('', []),
      [this.cClientOfficealias]: new FormControl('', []),
      [this.cClientSex]: new FormControl('', []),

      [this.cProjectId]: new FormControl('', []),
      [this.cProjectName]: new FormControl('', [Validators.required, Validators.maxLength(255), StringValidators.noSpacesEndStart]),
      [this.cEffectiveDate]: new FormControl(new Date(), [Validators.required]),
      [this.cPaymentType]: new FormControl('', [Validators.required]),
      [this.cActivity]: new FormControl('', [Validators.required]),
      [this.cSport]: new FormControl('', []),
      [this.cLifeDrivingForce]: new FormControl('', []),
      [this.cLifeScaffoldRoof]: new FormControl('', []),
      [this.cLifeSpecialRisks]: new FormControl('', []),
      [this.cLifeMotorbike]: new FormControl('', []),
      [this.cIndustryLife]: new FormControl(true, []),
      [this.cIndustryAccident]: new FormControl(true, []),
      [this.cIndustryTemporaryIncapacity]: new FormControl(true, []),
      [this.cIndustryDependency]: new FormControl(true, []),
      [this.cIndustryWholeLife]: new FormControl(true, []),
      [this.cIndustryDeath]: new FormControl(true, []),
      [this.cLivingStandard]: new FormControl('', []),
      [this.cDeadlineIpt]: new FormControl('', []),
      [this.cContributionReta]: new FormControl('', []),
      [this.cContributionGeneralRegime]: new FormControl('', []),
      [this.cMarried]: new FormControl('', []),
      [this.cMutualIncome]: new FormControl('', []),
      [this.cMinorChildren]: new FormControl('', [])
    });

    this.editForm.get(this.cClientId)?.disable();
    this.editForm.get(this.cClientName)?.disable();
    this.editForm.get(this.cClientBirthdate)?.disable();
    this.editForm.get(this.cClientAge)?.disable();
    this.editForm.get(this.cClientProfession)?.disable();
    this.editForm.get(this.cClientProvince)?.disable();
    this.editForm.get(this.cClientActuarialage)?.disable();
    this.editForm.get(this.cProjectId)?.disable();
    this.editForm.get(this.cClientSex)?.disable(); 

    this.initAccessors();
  }

  private initAccessors(): void {
    const map: Record<string, string> = {
      projectClientId: this.cClientId,
      projectClientName: this.cClientName,
      projectClientBirthDate: this.cClientBirthdate,
      projectClientAge: this.cClientAge,
      projectClientProfession: this.cClientProfession,
      projectClientProvince: this.cClientProvince,
      projectClientActuarialAge: this.cClientActuarialage,
      projectClientAddressZipCode: this.cClientAddresszipcode,
      projectClientOfficeAlias: this.cClientOfficealias,
      projectClientOfficeCode: this.cClientOfficecode,
      projectClientOfficeName: this.cClientOfficename,
      projectClientProfessionCode: this.cClientProfessioncode,
      projectClientSex: this.cClientSex,
      projectId: this.cProjectId,
      projectName: this.cProjectName,
      projectEffectiveDate: this.cEffectiveDate,
      projectPaymentType: this.cPaymentType,
      projectActivity: this.cActivity,
      projectSport: this.cSport,
      projectIndustryLife: this.cIndustryLife,
      projectIndustryAccident: this.cIndustryAccident,
      projectIndustryTemporaryIncapacity: this.cIndustryTemporaryIncapacity,
      projectIndustryDependency: this.cIndustryDependency,
      projectIndustryWholeLife: this.cIndustryWholeLife,
      projectIndustryDeath: this.cIndustryDeath,
      projectLivingStandard: this.cLivingStandard,
      projectDeadlineIPT: this.cDeadlineIpt,
      projectContributionRETA: this.cContributionReta,
      projectContributionGeneralReg: this.cContributionGeneralRegime,
      projectMarried: this.cMarried,
      projectMutualIncome: this.cMutualIncome,
      projectMinorChildren: this.cMinorChildren,
      projectLifeDrivingForce: this.cLifeDrivingForce,
      projectLifeScaffoldRoof: this.cLifeScaffoldRoof,
      projectLifeEspecialRisks: this.cLifeSpecialRisks,
      projectLifeMotorbike: this.cLifeMotorbike
    };

    Object.entries(map).forEach(([prop, control]) => {
      Object.defineProperty(this, prop, {
        get: () => this.getControl(control).value,
        set: (v: any) => this.getControl(control).setValue(v),
        enumerable: true,
        configurable: false
      });
    });
  }

  getControl(controlName: string): AbstractControl<any, any> {
    return this.editForm.get(controlName)!;
  }

  get form(): FormGroup {
    return this.editForm;
  }

  patch(data: any): void {
    this.form.patchValue(data);
  }

  toModel(): any {
    return this.form.value;
  }

  get children(): IMasterValue[] {
    return this.childrenData;
  }
  set children(vals: IMasterValue[]) {
    this.childrenData = vals;
  }

  get paymentTypes(): Array<IMasterValue> {
    return this.paymentTypesData;
  }
  set paymentTypes(paymentTypes: Array<IMasterValue>) {
    this.paymentTypesData = paymentTypes;
  }

  get activities(): Array<IMasterValue> {
    return this.activitiesData;
  }
  set activities(activities: Array<IMasterValue>) {
    this.activitiesData = activities;
  }

  get sports(): Array<IMasterValue> {
    return this.sportsData;
  }
  set sports(sports: Array<IMasterValue>) {
    this.sportsData = sports;
  }

  get livingStandards(): Array<IMasterValue> {
    return this.livingStandardsData;
  }
  set livingStandards(livingStandards: Array<IMasterValue>) {
    this.livingStandardsData = livingStandards;
  }

  get deadlineIPTs(): Array<IMasterValue> {
    return this.deadlineIPTsData;
  }
  set deadlineIPTs(deadlineIPTs: Array<IMasterValue>) {
    this.deadlineIPTsData = deadlineIPTs;
  }

  get contributionRETAs(): Array<IMasterValue> {
    return this.contributionRETAsData;
  }
  set contributionRETAs(contributionRETAs: Array<IMasterValue>) {
    this.contributionRETAsData = contributionRETAs;
  }

  get contributionGeneralRegs(): Array<IMasterValue> {
    return this.contributionGeneralRegsData;
  }
  set contributionGeneralRegs(contributionGeneralRegs: Array<IMasterValue>) {
    this.contributionGeneralRegsData = contributionGeneralRegs;
  }

  get mutualIncomes(): Array<IMasterValue> {
    return this.mutualIncomesData;
  }
  set mutualIncomes(mutualIncomes: Array<IMasterValue>) {
    this.mutualIncomesData = mutualIncomes;
  }

  get motorbikes(): Array<IMasterValue> {
    return this.motorbikesData;
  }
  set motorbikes(motorbikes: Array<IMasterValue>) {
    this.motorbikesData = motorbikes;
  }

  get yesNoValues(): KeyValue<YesNoValue, string>[] {
    return this.yesNoValuesData;
  }
  set yesNoValues(yesNoValues: KeyValue<YesNoValue, string>[]) {
    this.yesNoValuesData = yesNoValues;
  }

  get maritalStatuses(): IMasterValue[] {
    return this.maritalStatusesData;
  }
  set maritalStatuses(vals: IMasterValue[]) {
    this.maritalStatusesData = vals;
  }
}
